var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApiFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41139",
    "data-name": "Group 41139",
    transform: "translate(-169 -339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41016",
    "data-name": "Group 41016",
    transform: "translate(4.382 204.382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_717",
    "data-name": "Ellipse 717",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(164.618 134.618)",
    fill: "#e9dfdf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_716",
    "data-name": "Ellipse 716",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(167.618 137.618)",
    fill: "#d54d4d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cross",
    d: "M28.694,30.129a2.68,2.68,0,0,1-3.791,0L18.98,23.36l-5.923,6.766a2.681,2.681,0,0,1-3.791-3.791L15.428,19.3,9.265,12.257a2.681,2.681,0,0,1,3.791-3.791l5.924,6.772L24.9,8.466a2.681,2.681,0,0,1,3.791,3.791L22.532,19.3l6.162,7.037A2.683,2.683,0,0,1,28.694,30.129Z",
    transform: "translate(184.521 354.32)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiFailed);
export default __webpack_public_path__ + "static/media/apiFailed.92d455ecf6b4b69a141720eba6225d0d.svg";
export { ForwardRef as ReactComponent };